import { ArrowRight } from "lucide-react";

const LeadMagnetSection = ({ onOpenSketch }) => {
  return (
    <section data-testid="lead-magnet-section" className="light-band-2 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="scroll-animate-stagger scroll-animate grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-sora font-bold text-3xl sm:text-4xl text-ink-text">
              Kérsz egy gyors, célzott{" "}
              <span className="text-primary">weboldal-ajánlatot</span>?
            </h2>
            <p className="mt-6 text-muted-text">
              Ha röviden leírod:
            </p>
            <ul className="mt-4 space-y-2 text-ink-text/80">
              <li className="flex items-center gap-2">
                <ArrowRight size={16} className="text-primary" />
                mivel foglalkozol,
              </li>
              <li className="flex items-center gap-2">
                <ArrowRight size={16} className="text-primary" />
                ki a célcsoportod,
              </li>
              <li className="flex items-center gap-2">
                <ArrowRight size={16} className="text-primary" />
                mi a fő ajánlatod,
              </li>
            </ul>
            <p className="mt-6 text-muted-text">
              akkor kapsz tőlünk egy landing irányt: headline-javaslat + CTA irány + struktúra-vázlat (hogy lásd, milyen logikával építenénk fel).
            </p>
          </div>

          <div className="card-light rounded-3xl p-8">
            <button
              onClick={onOpenSketch}
              className="w-full bg-gradient-to-r from-primary to-accent text-white rounded-full py-4 font-semibold shadow-glow hover:shadow-glow-lg transition-all btn-glow"
              data-testid="lead-magnet-cta"
            >
              Kérek egy ajánlatot
            </button>
            <p className="mt-4 text-center text-sm text-muted-text">
              Nem kell hosszú leírás. Elég 4–5 mondat.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnetSection;
